'use client';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';

import MainPage from './mainpage';



const HomePage = () => {
  return (
    <div data-component-id="src/app/HomePage.tsx:12:4" data-component-path="src/app/HomePage.tsx" data-component-line="12" data-component-end-line="21" data-component-file="HomePage.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20bg-white%22%7D" className="w-full bg-white">
      <Header data-component-id="src/app/HomePage.tsx:13:6" data-component-path="src/app/HomePage.tsx" data-component-line="13" data-component-end-line="13" data-component-file="HomePage.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />

      <main data-component-id="src/app/HomePage.tsx:15:6" data-component-path="src/app/HomePage.tsx" data-component-line="15" data-component-end-line="18" data-component-file="HomePage.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22flex%20flex-col%20gap-%5B22px%5D%20justify-start%20items-center%20w-full%22%7D" className="flex flex-col gap-[22px] justify-start items-center w-full">
        <MainPage data-component-id="src/app/HomePage.tsx:16:8" data-component-path="src/app/HomePage.tsx" data-component-line="16" data-component-end-line="16" data-component-file="HomePage.tsx" data-component-name="MainPage" data-component-content="%7B%22elementName%22%3A%22MainPage%22%7D" /> 
        
      </main>

      <Footer data-component-id="src/app/HomePage.tsx:20:6" data-component-path="src/app/HomePage.tsx" data-component-line="20" data-component-end-line="20" data-component-file="HomePage.tsx" data-component-name="Footer" data-component-content="%7B%22elementName%22%3A%22Footer%22%7D" />
    </div>
  );
};

export default HomePage;